
import React from 'react';
import PropTypes from 'prop-types';
import { Brightness as BrightnessIcon } from '../../../element/icons';


import ToolsBarItemButton from '../../../components/ToolsBar/ToolsBarItemButton';
import { TOOLS_IDS } from '../../../utils/constants';

const Brightness = ({ selectTool, isSelected = false, t }) => (
  <ToolsBarItemButton
    className="respark_brightness-tool-button"
    id={TOOLS_IDS.BRIGHTNESS}
    label={t('brightnessTool')}
    Icon={BrightnessIcon}
    onClick={selectTool}
    isSelected={isSelected}
  />
);


Brightness.propTypes = {
  selectTool: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default Brightness;
